function Finished() {
  return (
    <div className="done">
      <h1>Formulário enviado com sucesso</h1>
    </div>
  );
}

export default Finished;
